import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Routes from "./routes";
import { ChatBox, Navbar } from "@components";
import "./services/i18n";

import "bootstrap/scss/bootstrap.scss";
import "bootstrap";
import "./assets/scss/custom.scss";

function App() {
  const location = useLocation;

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return (
    <div className="App">
      <Navbar />
      <Routes />
      <ChatBox />
    </div>
  );
}

export default App;
